<template>
  <v-container fluid class="resGray lighten-6">
    <v-app-bar flat>
      <date-picker
        class="ml-2 mr-3"
        :label="'As of date'"
        :defaultNull="true"
        :initialDate="selectedDate"
        @dateSelected="updateSelectedDate">
      </date-picker>
      <drop-down
        label="Property Name"
        class="mb-5"
        :selectedValue="{ text: propertyName }"
        :items="'Properties'"
        :multiple='false'
        width="250px"
        @itemSelected="selectProperty">
      </drop-down>
      <v-spacer></v-spacer>
      <search
        @searchStringUpdated="updateSearchString"
        placeholder='Enter check # or lease name'
        :width="'250px'"
        class="mt-4 mr-2">
      </search>
    </v-app-bar>
    <v-row>
      <v-col cols="12">
        <data-table
          :headers="headers"
          :tableData="getData"
          @DeleteCheck="openDeleteDialog"
          @ShowCheckDetails="openDepositDetails"
          :searchString="searchString"
          :noData="'Please use search criteria above for results.'"
          class="mx-6">
        </data-table>
       </v-col>
    </v-row>
    <!-- Dialogs -->
    <delete-dialog
      :showDialog="deleteConfirm"
      v-if="deleteConfirm"
      :title="'Are you sure?'"
      confirmButton="Yes, delete check"
      confirmButtonWidth="108px"
      @confirmDelete="confirmDialog"
      message="Please confirm that you would like to delete this check. Doing so will reverse all charges this check is applied to and remove it from the system."
      @cancelDelete="cancelDialog">
      <v-flex>
        <v-layout mt-4 ml-6>
          <v-flex>
            <div class="caption resGray-darken1--text mb-1">Check date</div>
            <div class="caption">{{ currentCheckToDelete.payerCheckDate }}</div>
          </v-flex>
          <v-flex>
            <div class="caption resGray-darken1--text mb-1">Check number</div>
            <div class="caption">{{ currentCheckToDelete.payerCheckNumber }}</div>
          </v-flex>
          <v-flex mr-6>
            <div class="caption resGray-darken1--text mb-1 text-right">Check total</div>
            <div class="caption text-right">{{ currentCheckToDelete.baseAmount }}</div>
          </v-flex>
        </v-layout>
      </v-flex>
    </delete-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DropDown from '../../../BaseComponents/DropDown'
import DatePicker from '../../../BaseComponents/DatePicker'
import Search from '../../../BaseComponents/Search'
import DataTable from '../../../BaseComponents/Table'
import DeleteDialog from '../../../BaseComponents/DeleteDialog'
import moment from 'moment'
import * as currency from '../../../../utility/currency'
export default {
  props: ['previousProperty', 'previousDate'],
  components: {
    Search,
    DropDown,
    DatePicker,
    DataTable,
    DeleteDialog
  },
  data () {
    return {
      property: this.previousProperty.value,
      propertyName: this.previousProperty.text,
      selectedDate: this.previousDate,
      deleteConfirm: false,
      currentCheckToDelete: {},
      searchString: ''
    }
  },
  methods: {
    ...mapActions(['fetchData', 'changeData', 'initializeStoreItem']),
    updateSelectedDate (val) {
      this.selectedDate = val
      this.getChecks()
    },
    selectProperty (val) {
      this.propertyName = val.text
      this.property = val.value
      this.getChecks()
    },
    getChecks () {
      if ((this.selectedDate !== null && this.selectedDate !== undefined) && ((this.property !== null && this.property !== undefined))) {
        this.fetchData({newPage: 'BankDepositDetailsDelete', params: { Property: this.property, AsOfDate: this.selectedDate }}).catch(error => { console.log(error.response) })
      }
    },
    updateSearchString (val) {
      this.searchString = val
    },
    openDepositDetails (val) {
      let property = {
        value: this.property,
        text: this.propertyName
      }
      this.$emit('setProperty', property)
      this.$emit('setDate', this.selectedDate)
      this.$emit('openCheckDetails', val)
    },
    openDeleteDialog (val) {
      val.payerCheckDate = moment(val.payerCheckDate).format('L')
      val.baseAmount = currency.convertToCurrency(val.baseAmount)
      this.currentCheckToDelete = val
      this.deleteConfirm = true
    },
    cancelDialog () {
      this.deleteConfirm = false
    },
    confirmDialog () {
      this.changeData({ currentPage: 'BankDepositDetailsDelete',
        newData: {
          CompanyId: this.currentCheckToDelete.companyId,
          BankAccountCode: this.currentCheckToDelete.bankAccountCode,
          DepositSlipId: this.currentCheckToDelete.depositSlipId,
          BankDepositId: this.currentCheckToDelete.depositId,
          Payer: this.currentCheckToDelete.payer,
          PayerType: this.currentCheckToDelete.payerType,
          PayerCheckNumber: this.currentCheckToDelete.payerCheckNumber,
          PayerCheckDate: this.currentCheckToDelete.payerCheckDate
        } }).then(() => {
        this.fetchData({newPage: 'BankDepositDetailsDelete', params: { Property: this.property, AsOfDate: this.selectedDate }})
        this.deleteConfirm = false
      }).catch(error => { console.log(error.response) })
    }
  },
  computed: {
    ...mapGetters(['currentData', 'currentHeaders']),
    canSearch () {
      if ((this.selectedDate !== null && this.selectedDate !== undefined) && ((this.property !== null && this.property !== undefined))) {
        return true
      }
      return false
    },
    getData () {
      return this.currentData('BankDepositDetailsDelete')
    },
    headers () {
      return this.currentHeaders('BankDepositDetailsDelete')
    }
  },
  created () {
    this.fetchData({ newPage: 'BankDepositDetailsDelete' }).catch(error => { console.log(error.response) })
  }
}
</script>
